import React from 'react';
import { ExternalReactRenderers } from '../../../components/Editor/types';
import cn from 'classnames';
import {
  DaDeviationThumbAttrs,
  DaDeviationThumbOptions,
} from '../deviation-thumb';
import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useSize } from '../hooks/useSize';

import s from './Viewer.scss';

export interface Props {
  externalRenderers: ExternalReactRenderers;
  node: TipTapBaseNode;
}

const Viewer = (props: Props) => {
  const attrs: DaDeviationThumbAttrs = props.node
    .attrs as DaDeviationThumbAttrs;
  const { deviation } = attrs;
  const Renderer = props.node.externalRenderers?.inline;
  const config = props.node.extensionConfig
    ?.deviationThumb as DaDeviationThumbOptions;

  const { width, height } = useSize(
    props.node.externalRenderers.mediaService,
    attrs,
    config,
    props.node.containerWidth
  );

  return (
    <div
      className={cn(s[`preset-${props.node.presetId}`], s['outer-span'])}
      data-da-type="da-deviation-thumb"
      data-deviation={JSON.stringify(deviation)}
      data-width={attrs.width}
      data-height={attrs.height}
      data-cropping={attrs.cropping}
      data-link={attrs.link}
      data-aspect={attrs.aspect}
    >
      <ErrorBoundary
        debugComponent="editorExtDeviationViewer"
        humanError="Oops, this deviation could not be shown."
      >
        <Renderer
          deviation={attrs.deviation}
          width={width}
          height={height}
          crop={attrs.cropping}
          link={attrs.link}
          extOptions={config}
        />
      </ErrorBoundary>
    </div>
  );
};

export default Viewer;
